export default function Footer() {
  return (
    <footer className="bg-slate-950 text-slate-500 text-center py-6 text-sm">
      <p>© {new Date().getFullYear()} Lydie. Built with React, MUI, Ant Design & Tailwind 💜</p>
    </footer>
  );
}
